import React from 'react';
import { useParams } from "react-router-dom";
import UseCasePage from '../Build/IntegrationsBySolution/UseCasePage';

export function UseCasePreview() {
  const { useCaseID } = useParams();
  return <UseCasePage id={useCaseID} useCasePreview={true} />
}